import { routes } from "routes/routes";

import { ReactComponent as HomeIcon } from "assets/images/sideMenu/home-icon.svg";
import { ReactComponent as InvoicesIcon } from "assets/images/sideMenu/invoices-icon.svg";
import { ReactComponent as AccountsIcon } from "assets/images/sideMenu/accounts-icon.svg";

import { ReactComponent as IntegrationIcon } from "assets/images/sideMenu/integration-icon.svg";
import { ReactComponent as ApiTokenIcon } from "assets/images/sideMenu/api-key-icon.svg";

import { ReactComponent as SettingsIcon } from "assets/images/sideMenu/settings-icon.svg";

import { ReactComponent as SupportIcon } from "assets/images/sideMenu/support-icon.svg";
import { ReactComponent as FaqIcon } from "assets/images/sideMenu/faq-icon.svg";

import { featureFlag } from "shared/constants/posthog";

import { MenuItemI } from "./SideMenuItem";

export const sideMenuMainItems: MenuItemI[][] = [
  [
    { route: routes.home, icon: HomeIcon, name: "Головна" },
    {
      route: routes.invoices,
      icon: InvoicesIcon,
      name: "Мої посилання",
      premium: true,
    },
    {
      route: routes.accounts,
      icon: AccountsIcon,
      name: "Мої реквізити",
      premium: true,
    },
  ],
  [
    {
      route: routes.integrations,
      icon: IntegrationIcon,
      name: "Інтеграції",
      premium: true,
      featureFlag: featureFlag.bank_integration_feature_enabled,
    },
    {
      route: routes.apiToken,
      icon: ApiTokenIcon,
      name: "API Токен",
      premium: true,
    },
  ],
  [
    {
      route: routes.settings,
      icon: SettingsIcon,
      name: "Налаштування",
      premium: true,
    },
  ],
];

export const sideMenuBottomItems: MenuItemI[] = [
  { route: routes.support, icon: SupportIcon, name: "Служба підтримки" },
  { route: routes.faq, icon: FaqIcon, name: "Часті запитання" },
];
